export type PlanCode = 'fffvip' | 'fffvipa';

const ANNUAL_PLAN_CODE: PlanCode = 'fffvipa';
const SEASONAL_PLAN_CODE: PlanCode = 'fffvip';

export {
  ANNUAL_PLAN_CODE,
  SEASONAL_PLAN_CODE,
};
